<div class="w-full h-full">
  <canvas
    class="m-0"
    [data]="barChartData"
    [options]="barChartOptions"
    [plugins]="chartPlugins"
    [type]="'bar'"
    baseChart
    height="90px"></canvas>
</div>
